// plugins/toast.js
import Vue from 'vue';
import ToastComponent from '@/components/Toast.vue'; // 根据实际路径调整

const Toast = {};

// 安装插件
Toast.install = function (Vue, options = {}) {
  // 1. 创建 Toast 组件的实例，并挂载到一个 div 上
  const ToastConstructor = Vue.extend(ToastComponent);
  const instance = new ToastConstructor();
  const vm = instance.$mount(); // 渲染得到真实 DOM
  document.body.appendChild(vm.$el); // 插入 body

  // 2. 定义全局方法
  const toast = {
    show(message, type = 'info', duration = 3000) {
      instance.add({ message, type, duration });
    },
    info(message, duration) {
      this.show(message, 'info', duration);
    },
    success(message, duration) {
      this.show(message, 'success', duration);
    },
    error(message, duration) {
      this.show(message, 'error', duration);
    },
    warning(message, duration) {
      this.show(message, 'warning', duration);
    },
    clear() {
      instance.clear();
    },
  };

  // 3. 挂载到 Vue 原型上，所有组件均可通过 this.$toast 访问
  Vue.prototype.$toast = toast;
};

export default Toast;